import store from '../store/index'
//持久
let user = localStorage.getItem('user')
if(user){
  user = JSON.parse(user);
  store.commit('loginModule/setUser',user)
}
let theme = localStorage.getItem('theme')
if(theme){
	theme=JSON.parse(theme);
    store.state.settings.theme=theme;
}

